import { createFileRoute } from '@tanstack/react-router'
import { ApprovalsInboxPage } from '../../../features/approvals/inbox-page'
import { approvalsSearchSchema } from '../../../features/approvals/search'

export const Route = createFileRoute('/_app/approvals/')({
  validateSearch: approvalsSearchSchema,
  component: ApprovalsInboxPage,
})
